module.exports = __webpack_public_path__ + "img/58955e4.png";